import humanize from 'humanize-string'
import pluralize from 'pluralize'
import titleize from 'titleize'

import AttachmentMixin from '@/mixins/AttachmentMixin'

import FlashStore from '@/stores/FlashStore'

import { mapState } from 'vuex'

export default {
  props: {
    emailId: {
      type: [ Number, String ],
      default: undefined
    },

    emailType: {
      type: String,
      default: 'targeted_email'
    },

    newsletterId: {
      type: [ Number, String ],
      default: undefined
    }
  },

  computed: mapState({
    attachments () {
      return this.isNewsletter ? this.email.newsletter_attachments : this.email.email_attachments
    },

    baseId () {
      return this.emailId || this.newsletterId || (
        this.email && this.email.id
      )
    },

    canDequeue () {
      return this.isNewsletter && !this.canQueue
    },

    canQueue () {
      return this.email.sent_recipient_count === 0 && this.email.unsent_recipient_count === 0
    },

    canRequeue () {
      return this.email.unsent_recipient_count === 0 && this.email.sent_recipient_count > 0
    },

    displayActionStatus () {
      return this.email.inactive ? 'Drafted' : ''
    },

    displayName () {
      return this.isNewsletter ? 'Newsletter' : 'Email'
    },

    hasId () {
      return this.baseId
    },

    idName () {
      return this.relationalIdName + 'Id'
    },

    isEmail () {
      return !this.isNewsletter
    },

    isNewsletter () {
      return (this.emailType === 'newsletter') || this.newsletterId
    },

    emailUrl () {
      return this.apiUrl(`/${this.emailType}s/` + this.baseId, true)
    },

    relationalIdName () {
      return (this.isNewsletter ? 'newsletter' : 'email')
    },

    pluralIdName () {
      return pluralize(this.relationalIdName)
    },

    pluralModelType () {
      return pluralize(this.modelType)
    },

    modelType () {
      return (this.isNewsletter ? 'newsletter' : 'targeted_email')
    },

    initializeMethod () {
      return 'getNew' + this.displayName
    },

    needsPuzzle () {
      return this.shouldHavePuzzle && !this.email.puzzles.length
    },

    needsQueuing () {
      return this.isNewsletter && this.canQueue && !this.queued_at
    },

    prettySendAtLocal () {
      return this.$root.prettyDateTimeLocalFmt(this.email.send_at)
    },

    recipientRoute () {
      return (this.isNewsletter ? 'newsletter' : 'email') + '_recipient'
    },

    retrievalMethod () {
      return 'getAdmin' + this.displayName
    },

    sendImmediately () {
      return Date.parse(this.email.send_at) <= new Date()
    },

    shouldHavePuzzle () {
      return this.email.newsletter_type && this.email.newsletter_type.requires_subscription
    },

    title () {
      return titleize(humanize(this.emailType))
    },

    base: state => state.base,
    email: state => state.EmailModule.email,
    puzzle: state => state.PuzzleModule.puzzle
  }),

  mixins: [ AttachmentMixin ],

  methods: {
    get () {
      return this.$store.dispatch(
        `EmailModule/${this.retrievalMethod}`, this.baseId
      ).catch(
        this.$root.processErrors
      )
    },

    confirmEmail () {
      return this.$store.dispatch(
        `EmailModule/confirmEmail`, {
          emailType: this.pluralModelType,
          id: this.baseId
        }
      ).catch(err => {
        this.$root.processErrors(err)
      })
    },

    modelInputId (attr) {
      return this.modelType + '-' + attr
    },

    modelInputName (attr) {
      return this.modelType + `[${attr}]`
    },

    queue () {
      if (!this.promptForPuzzle()) { return }
      if (!this.promptForConfirmation()) { return }

      if (
        confirm(`Are you sure you want to queue this ${this.emailType}? If so, the ${this.emailType} will be immediately queued to send.`)
      ) {
        this.loading = true

        this.$http.post(this.emailUrl + '/queue').then((resp) => {
          this.loading = false

          FlashStore.result('This email has been queued for sending.')
          this.get()
        }, this.$root.processErrors)
      }
    },

    promptForConfirmation () {
      if (!this.email.confirmed_at) {
        if (
          confirm(
            `This email needs to be confirmed via a preview email. Do you want to send a preview email to your email address?`
          )
        ) {
          this.$http.post(this.emailUrl + '/send_confirmation').then((resp) => {
            this.loading = false

            FlashStore.result('A preview email has been sent.')
            this.get()
          }, this.$root.processErrors)
        }
      } else {
        return true
      }
    },

    promptForPuzzle () {
      if (this.needsPuzzle) {
        if (confirm(`There's no puzzle attached to this ${this.relationalIdName}! Are you sure you want to continue?`)) {
          return true
        }
      } else {
        return true
      }
    },

    publish () {
      if (this.promptForConfirmation()) {
        if (confirm(`Are you sure you want to move this email out of draft mode? ${this.sendImmediately ? 'It will be sent to users immediately' : 'It will be sent at ' + this.prettySendAtLocal}.`)) {
          this.$store.dispatch(
            `EmailModule/publish${this.displayName}`, this.emailId
          ).catch(this.$root.processErrors)
        }
      }
    },

    recipientParams (item) {
      return this.newsletterId ? {
        emailId: item.newsletter_id,
        newsletterRecipientId: item.id
      } : {
        recipientId: item.id
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/EmailMixin.js